import { gql } from '@apollo/client';

export const getTreatyDetailsQuery = gql`
  query getTreatyDetails($id: String!) {
    reinsurance {
      getTreatyDetails(id: $id) {
        id
        name
        code
        type
        status
        treatyEffectiveDate
        treatyExpiryDate
        currency {
          id
          code
          symbol
          title
          titleAr
        }
        underwritingLimit
        claimAdviseLimit
        substandardLimit
        companyId
        leaderReinsurerID
        createdBy
        createdOn
        modifiedBy
        modifiedOn
        leaderReinsurer {
          id
          fullName
          code
          registerationNumber
          isLocal
          isCompany
          status
          relatedCompany
          auxiliaryAccount
          person {
            fullName
            firstName
            lastName
            gender
            nationalityId
            profession
            dateOfBirth
            cityOfBirth
          }
        }
        relatedCompany {
          id
          code
          title
        }
        treatyLayers {
          id
          treatyID
          layerOrder
          layerType
          quoteSharePercentage
          premiumRate
          paymentAmount
          paymentDate
          totalTreatyPremium
          createdBy
          createdOn
          modifiedBy
          modifiedOn
          categories {
            aggregateLimit
            category
            commissionRate
            createdBy
            createdOn
            id
            liabilityLimit
            maximumLayerLimit
            minimumLayerLimit
            modifiedBy
            modifiedOn
            priorityLimit
            retentionLimit
            totalExpectedPremium
            treatyID
            treatyLayerID
          }
        }
      }
      getTreatyReinsurers(treatyId: $id) {
        id
        isLeader
        sharePercentage
        reinsurer {
          fullName
        }
      }
    }
  }
`;

export const getTreatyTypeLovsQuery = gql`
  query TreatyTypeList {
    TreatyTypeList: __type(name: "TreatyType") {
      enumValues {
        name
      }
    }
  }
`;

export const getCurrenciesQuery = gql`
  query getCurrencies {
    core {
      getCurrencies {
        id
        code
        title
        symbol
      }
    }
  }
`;
export const getRelatedCompaniesQuery = gql`
  query {
    salesforce {
      getRelatedCompanies {
        id
        title
        code
      }
    }
  }
`;

export const getTreatySubTypesQuery = gql`
  query getTreatySubTypes {
    reinsurance {
      getLayerTypes {
        id
        title
        code
        treatyType
      }
    }
  }
`;

export const getCategoryEnumQuery = gql`
  query GetSublineCategoryList {
    SublineCategoryList: __type(name: "SublineCategoryList") {
      enumValues {
        name
      }
    }
  }
`;

export const activateTreatyMutation = gql`
  mutation activateTreaty($treatyId: String!) {
    reinsurance {
      activateTreaty(treatyId: $treatyId)
    }
  }
`;

export const closeTreatyMutation = gql`
  mutation closeTreaty($treatyId: String!) {
    reinsurance {
      closeTreaty(treatyId: $treatyId)
    }
  }
`;

export const getTreatyAuditTrailsQuery = gql`
  query getEntityAuditTrails($id: String!) {
    core {
      getEntityAuditTrails(id: $id) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;

export const reactivateTreatyMutation = gql`
  mutation ReactivateTreaty($treatyId: String!, $expiryDate: DateTime!) {
    reinsurance {
      reactivateTreaty(treatyId: $treatyId, expiryDate: $expiryDate)
    }
  }
`;
